import { useEffect, useState } from "react";
import '../fabric.css'
import './embroidery.css'

import tick from '../../assets/icon/tick1.png'
import one_button from "../../assets/SVG/SINGLE BUTTON-01.svg";
import { changeImgState, getRowsFromArray } from "../../Functions";

function Embroidery({sel, setSel, embroidery, embroideryStyle, getStyleImg, menuOpenEmb, setMenuOpenEmb, isMobile, embHoverDetails, setEmbHoverDetails, imgState, setImgState, setLoading}) {

    const [embStyles, setEmbStyles] = useState([])

    const [embCollections, setEmbCollections] = useState([])

    const [select, setSelect]=  useState(0)

    const [currDesign, setCurrDesign] = useState()
    const [currDesignName, setCurrDesignName] = useState("")

    const [searchQuery, setSearchQuery] = useState("");
    const [filterType, setFilterType] = useState("All"); // Suit/Shirt or Handwork/Machine

    useEffect(()=>{
        if(embroidery){
            let uniq = {}
            embroidery.forEach(element => {
                element.values.forEach((ele)=>{
                    uniq[ele.style] = 1;
                })
            });
            const a = []
            Object.keys(uniq).forEach((emb)=>{
                const style = embroideryStyle.find(ele => ele.id === emb);
                if(style){
                   a.push(style) 
                }
            })
            setEmbStyles(a)
        }
    }, [embroidery])

    useEffect(()=>{
        if(currDesign){
            getEmbStyle()
        }
    }, [currDesign])

    const getEmbStyle = ()=>{
        const colls = [];
        embroidery.forEach((ele, index)=>{
            const val = ele.values?.filter((element)=> element.style === currDesign )
            console.log("from getEMbStyles :", val);
            if(val && val.length) colls.push(ele)
        })
        setEmbCollections([...colls])
    }

    const selectEmb= (embroidery)=>{

        let embList = sel["embroidery"] ?? []
        const embId = embroidery.id

        if(!hasEmb(embId)){
            embList = [{...embroidery}]
            changeImgState()
            getStyleImg({...sel, ...{"embroidery":[...embList]}}, 0).then(()=>{})
            // setSel({...sel, ...{"embroidery":[...embList]}})
        } else {
            // embList = embList.filter((ele)=> ele.id != embId )
            // if(embList.length){
            //     getStyleImg({...sel, ...{"embroidery":[...embList]}}, 0).then(()=>{})
            // } else {
                let Obj  = {...sel}
                delete Obj["embroidery"]
                getStyleImg({...Obj}, 0).then(()=>{})
            //}
        }
    }

    const changeImgState = ()=>{
        if(imgState !== 1 && imgState !== 0){
            setLoading(true)
            setImgState(1)
        }
    }

    const hasEmb = (embId)=>{
        let embList = sel["embroidery"] ?? []

        const hasId = embList.filter((element)=> element.id === embId)

        if(!hasId.length){
            return false;
        } 
        return true;
    }

    const resetSelection = ()=>{
        let Obj  = {...sel}
        delete Obj["embroidery"]
        getStyleImg({...Obj}, 0).then(()=>{})
        setCurrDesign(null)
        setCurrDesignName("")
        setSelect(0)
    }

    return (
    <div className={`embroiderySection  ${isMobile ? (menuOpenEmb ? 'show' : 'hidden') : ''}`}>
        {(embroidery && embroidery.length >0) 
            ? (
            <>
            <div className="emb-sidebar-container">
                
                {/* Header Section */}
                <div className="emb-sidebar-header">
                    <h3>SELECT EMBROIDERY</h3>
                    
                    <div className="emb-status-bar">
                        <div className={`emb-status-step ${!currDesign ? 'active' : ''}`} onClick={() => { setSelect(0); setCurrDesign(null); }}>
                            1. Design
                        </div>
                        <div className="emb-status-arrow">→</div>
                        <div className={`emb-status-step ${currDesign ? 'active' : ''}`}>
                            2. Placement
                        </div>
                    </div>

                    <div className="emb-controls">
                        {select === 0 && (
                            <>
                            <div className="emb-search-box">
                                <input 
                                    type="text" 
                                    placeholder="Search embroidery..." 
                                    value={searchQuery}
                                    onChange={(e) => setSearchQuery(e.target.value)}
                                />
                            </div>
                            <div className="emb-filter-tabs">
                                <div className={`emb-filter-tab ${filterType === 'All' ? 'active' : ''}`} onClick={() => setFilterType('All')}>All</div>
                                <div className={`emb-filter-tab ${filterType === 'Handwork' ? 'active' : ''}`} onClick={() => setFilterType('Handwork')}>Handwork</div>
                                <div className={`emb-filter-tab ${filterType === 'Machine' ? 'active' : ''}`} onClick={() => setFilterType('Machine')}>Machine</div>
                            </div>
                            </>
                        )}
                        {select === 1 && (
                            <div className="emb-back-control" onClick={() => { setSelect(0); setCurrDesign(null); }}>
                                <span>← Back to Designs</span>
                            </div>
                        )}
                    </div>

                    {sel && sel.embroidery && (
                        <div className="emb-current-selection">
                            <span>Selected: {sel.embroidery[0].name}</span>
                            <button className="emb-clear-btn" onClick={resetSelection}>Clear</button>
                        </div>
                    )}
                </div>

                {/* Content Section */}
                <div className="emb-content-scroll">
                    
                    {select === 0 ? (
                        // Design Selection Grid
                        <div className="emb-design-grid">
                            {embStyles && embStyles
                                .filter(emb => {
                                    const matchesSearch = emb.name.toLowerCase().includes(searchQuery.toLowerCase());
                                    const matchesFilter = filterType === 'All' || emb.type === filterType;
                                    return matchesSearch && matchesFilter;
                                })
                                .map((embroidery, index) => (
                                <div 
                                    key={index} 
                                    className={`emb-design-card ${currDesign === embroidery.id ? 'active' : ''}`} 
                                    onClick={() => {
                                        setSelect(1); 
                                        setCurrDesign(embroidery.id);
                                        setCurrDesignName(embroidery.name);
                                    }}
                                >
                                    <div className="emb-design-img-wrapper">
                                        <img src={embroidery.src} alt={embroidery.name} />
                                    </div>
                                    
                                    <div className="emb-card-info">
                                        <div className="emb-card-name-row">
                                            <span className="emb-card-name">{embroidery.name}</span>
                                            <span className="emb-card-divider">|</span>
                                            <span className="emb-card-type">{embroidery.type || 'Handwork'}</span>
                                        </div>
                                    </div>

                                    {/* Info Button */}
                                    <div 
                                        className="emb-info-btn"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setEmbHoverDetails({
                                                id: embroidery.id, name: embroidery.name, 
                                                src: embroidery.src, 
                                                single : [...embroidery.other_images],
                                                type : embroidery.type,
                                            });
                                        }}
                                    >
                                        i
                                    </div>

                                    {sel && sel.embroidery && sel.embroidery[0].style === embroidery.id && (
                                        <div className="selected-tick">✓</div>
                                    )}
                                </div>
                            ))}
                        </div>
                    ) : (
                        // Position Selection Grid
                        <div className="emb-position-grid">
                            {embCollections && embCollections.map((item, index) => (
                                <div 
                                    key={index}
                                    className={`emb-position-card ${hasEmb(item.id) ? 'selected' : ''}`}
                                    onClick={() => selectEmb(item)}
                                >
                                    <div className="emb-pos-img-wrapper">
                                        <img src={item.src} alt={item.name} />
                                    </div>

                                    <div className="emb-pos-info">
                                        <div className="emb-pos-name">{item.name || "Position"}</div>
                                        <div className="emb-pos-price">
                                            {(Number(item.price)).toLocaleString('en-IN', {
                                                maximumFractionDigits: 0,
                                                style: 'currency',
                                                currency: 'INR'
                                            })}
                                        </div>
                                    </div>

                                    {hasEmb(item.id) && <div className="selected-tick">✓</div>}
                                </div>
                            ))}
                        </div>
                    )}

                </div>
            </div>

            </>)
            : (<div className="no-emb">No Embroidery Available</div>)
        }
    </div> );

}

export default Embroidery;